<template>
    <div class="christmas-box" v-if="isTuEyeProtectionMode && isShowChristmasDialog" :class="boxShow?'':'box-hide'">
        <div class="app-dialogs" :class="show ? 'opens':'closes'">
            <img :src="appImg"/>
        </div> 
        <div class="christmas-overlay" v-if="show" @click="setBoxShow()"></div>
        
        <div class="snow-info" v-if="show" @click="setBoxShow()">
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
            <div class="snow"></div>
        </div>
    </div>
</template>
<script>
import appImg from '@/assets/img/specialEvents/Xmas_1.png' // 引入所需图片
import { formatDate } from '@/utils/date.js'
import dateFileter from '@/filters/dateFilter'

export default {
    data:()=>({
        isShow: true,
        show: false,
        appImg: appImg,
        boxShow: true,
        nowDate: null,
        startDate: '12-24-2020',
        endDate: '12-25-2020'
    }),
    mounted(){
       this.nowDate = formatDate(new Date(),'MM-dd-yyyy')
       if(this.nowDate != this.startDate || this.nowDate != this.endDate){
            this.show = false
            this.boxShow = false
       }
    },
    computed: {
        isTuEyeProtectionMode () {
            return this.$store.state.user.isTuEyeProtectionMode
        },
        isShowChristmasDialog () {
            return this.$store.state.user.isShowChristmasDialog
        }
    },
    methods: {
        setBoxShow(){
            this.show = !this.show
            this.boxShow = false
        }
    },
    watch: {
        isShowChristmasDialog (val, oldVal) {
            console.log(val, oldVal);
            if (val && (this.nowDate == this.startDate || this.nowDate == this.endDate)){
                setTimeout(() => {
                    this.show = true
                    this.boxShow = true
                }, 500)
            }
        }
    }
}
</script>
<style>
.christmas-box{
    height: 100vh;
    width: 100vw;
    position: fixed;
    bottom: 0;
    z-index: 999;
}
.box-hide{
    animation: boxHide 0s ease-in 1s forwards;
}
@keyframes boxHide {
    to {
        width:0;
        height:0;
        overflow:hidden;
    }
}
.app-dialogs{
    position: absolute;
    -webkit-transition: all .5s ease-in;
    transition: all .5s ease-in;
    left: 50%;
    margin-left: -213px;
    top: -750px;
    width: 426px;
    height: 640px;
    z-index: 500;
    top: 50%;
    margin-top: -1200px;
}

.christmas-overlay{
    background-color:#000;
    position: absolute;
    z-index:300;
    left:0;
    bottom:0;
    width:100vw;
    height:100vh;
    opacity:0.5;
}
.opens{
    margin-top: -320px;
}
.closes{
    margin-top: -1200px;
    display: none;
}

</style>
<style scoped>
  @import "./snow.css"
</style>
